import { render, staticRenderFns } from "./Item5.vue?vue&type=template&id=d17c6b3e&scoped=true&"
import script from "./Item5.vue?vue&type=script&lang=js&"
export * from "./Item5.vue?vue&type=script&lang=js&"
import style0 from "./Item5.vue?vue&type=style&index=0&id=d17c6b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17c6b3e",
  null
  
)

export default component.exports